import { useUser } from 'hooks/useUser'
import { useSearchParams } from 'react-router-dom'

const useIsIgnoringDeliveryModel = () => {
  const [searchParams] = useSearchParams()
  const { roleFlags } = useUser()
  const isAdmin = Boolean(roleFlags?.isAdmin)

  return isAdmin && searchParams.get('ignoreDeliveryModel') === 'true'
}

export { useIsIgnoringDeliveryModel }
